import { Surface } from '@storeblocks/surface';
import { css, styled } from 'styled-components';

const surfaceStyle = css`
  padding: 24px;
  border-radius: 8px;
`;

export const ConnectSurface = styled(Surface)`
  ${surfaceStyle}
`;
